import { render } from "./ContextMenu.vue?vue&type=template&id=6ddaffdc&scoped=true&ts=true"
import script from "./ContextMenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContextMenu.vue?vue&type=script&setup=true&lang=ts"

import "./ContextMenu.vue?vue&type=style&index=0&id=6ddaffdc&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ddaffdc"],['__file',"resources/js/components/ui/context-menu/ContextMenu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ddaffdc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ddaffdc', __exports__)) {
    console.log('reload')
    api.reload('6ddaffdc', __exports__)
  }
  
  module.hot.accept("./ContextMenu.vue?vue&type=template&id=6ddaffdc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('6ddaffdc', render)
  })

}


export default __exports__